module.exports = __webpack_public_path__ + "img/collection4@2x.cd56661a.png";